import React from 'react'
import MergeSquareCardMarginBox from '../../merge-common/layout/MergeSquareCardMarginBox'
import { HeightDiv } from '../../merge-common/providers/HeightProvider'
import { PersonCardContentSkeleton, heightDivTypeMap } from '../../merge-common/PersonCardContent'
import { personTypeMap } from '../../merge-common/helpers'
import { type PersonType } from '../../merge-common/types/general'

type Props = {
  personType: PersonType
}

/**
 * The loading person card for a merge column. Mirrors the real PersonSquareCard: the per-person background color
 * cue (e.g. blue for the final result) plus the shared "person-header" HeightDiv so the arrow aligns to the
 * person headers.
 */
export default function MergeColumnSkeleton({ personType }: Props): JSX.Element {
  return (
    <div style={{ backgroundColor: personTypeMap[personType].cardBackgroundColor }}>
      <MergeSquareCardMarginBox>
        <HeightDiv id="person-header" type={heightDivTypeMap[personType]}>
          <PersonCardContentSkeleton />
        </HeightDiv>
      </MergeSquareCardMarginBox>
    </div>
  )
}
